import { get, post, postWithDownloadFile } from './mainApi';

const resourcepoolServeiceBaseURL =
  process.env.REACT_APP_RESOURCE_POOL_ENDPOINT;

export const getResourcesData = async (startDate, endDate, isShared, isDelivery, allocationTypes) => {
  try {
    const data = {
      startDate: startDate,
      endDate: endDate,
      isShared: isShared,
      isDelivery: isDelivery,
      allocationTypes: allocationTypes
    }
    var response = post(resourcepoolServeiceBaseURL + 'Dashboard', data);
    return response;
  } catch (error) {}
};

export const getResources = async (data) => {
  try {
    var response = post(resourcepoolServeiceBaseURL + 'Resources?offset=' + data.offset + '&limit=' + data.limit, {
      resources: data.resource,
      clients: data.client,
      projects: data.project,
      resourceType: data.resourceType,
      allocationStartDate: data.allocationStartDate,
      allocationEndDate: data.allocationEndDate,
      allocationRoles: data.allocationRoles
    });
    return response;
  } catch (error) {}
};

export const getProjects = async (data) => {
  try {
    var response = post(resourcepoolServeiceBaseURL + 'Projects?offset=' + data.offset + '&limit=' + data.limit, {
      resources: data.resource,
      projects: data.project,
      resourceType: data.resourceType,
      allocationStartDate: data.allocationStartDate,
      allocationEndDate: data.allocationEndDate,
      allocationRoles: data.allocationRoles
    });
    return response;
  } catch (error) {}
};

export const downloadUtilizationReport = async (startDate, endDate, allocationTypes) => {
  let newUrl = `${resourcepoolServeiceBaseURL}utilization-report`;
  const response = postWithDownloadFile(newUrl, {
    startDate: startDate,
    endDate: endDate,
    allocationTypes: allocationTypes
  }, 'arraybuffer');
  return response;
};

export const downloadReourcesReport = async (data) => {
  try {
    let newUrl = `${resourcepoolServeiceBaseURL}resources-report`;
    const response = postWithDownloadFile(newUrl, {
      resources: data.resource,
      projects: data.project,
      resourceType: data.resourceType,
      allocationStartDate: data.allocationStartDate,
      allocationEndDate: data.allocationEndDate,
      allocationRoles: data.allocationRoles,
      offset: 0,
      limit: 0
    }, 'arraybuffer');
    return response;
  } catch (error) {}
};

export const downloadProjectsReport = async (data) => {
  try {
    let newUrl = `${resourcepoolServeiceBaseURL}projects-report`;
    const response = postWithDownloadFile(newUrl, {
      resources: data.resource,
      projects: data.project,
      resourceType: data.resourceType,
      allocationStartDate: data.allocationStartDate,
      allocationEndDate: data.allocationEndDate,
      allocationRoles: data.allocationRoles,
      offset: 0,
      limit: 0
    }, 'arraybuffer');
    return response;
  } catch (error) {}
};

export const getAllocationVariances = async (startDate, endDate, isShared, isDelivery, allocationType) => {
  try {
  let response = post(`${resourcepoolServeiceBaseURL}allocation-variances`, {
    startDate: startDate,
    endDate: endDate,
    isShared: isShared,
    isDelivery: isDelivery,
    allocationTypes: allocationType
  });
  return response;
  } catch (error) {}
};

export const getUnderutilizedResources = async (startDate, endDate, isShared, isDelivery, allocationType) => {
  try {
  let response = post(`${resourcepoolServeiceBaseURL}underutilized-resources-by-range`, {
    startDate: startDate,
    endDate: endDate,
    isShared: isShared,
    isDelivery: isDelivery,
    allocationTypes: allocationType
  });
  return response;
  } catch (error) {}
};

export const getOverutilizedResources = async (startDate, endDate, isShared, isDelivery, allocationType) => {
  try {
  let response = post(`${resourcepoolServeiceBaseURL}overutilized-resources-by-range`, {
    startDate: startDate,
    endDate: endDate,
    isShared: isShared,
    isDelivery: isDelivery,
    allocationTypes: allocationType
  });
  return response;
  } catch (error) {}
};
